/**
 * Format date to chat header style:
 * "Sunday, Mar 30"
 */
export default function formatChatDate(date: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric"
  }).format(date);
}
